import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { PhysicianDocPanel } from "@/components/app/physician-docs/physician-doc-panel";
import { orpc } from "@/lib/orpc";
import { useCan } from "@/lib/policy";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/physician-poc")({
  component: PhysicianDocumentsTab,
});

/** Two sibling physician documents, in the order a building fills them in: the admission-day Order
 * for Assisted Living, then the Plan of Care the physician has thirty days to certify. */
function PhysicianDocumentsTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const canWrite = useCan("resident.clinical:update", resident.facilityId);
  const props = { owner: { residentId }, facilityId: resident.facilityId, canWrite };

  return (
    <div className="space-y-6">
      {/* The panels title their sections at h3; this is the tab's own level. */}
      <h2 className="sr-only">Physician orders and plan of care</h2>
      <PhysicianDocPanel kind="order" {...props} />
      <div className="border-t pt-6">
        <PhysicianDocPanel kind="plan" {...props} />
      </div>
    </div>
  );
}
